import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "flex-grow-1 flex-sm-grow-0 equal-btn" }
const _hoisted_3 = { class: "flex-grow-1 flex-sm-grow-0 equal-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_AddTeilnehmerZugriffDialog = _resolveComponent("AddTeilnehmerZugriffDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { sm: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", {
                        class: "pl-3",
                        textContent: _toDisplayString(_ctx.$t('einstellungen.teilnehmerzugriff.title'))
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "d-flex flex-column flex-wrap flex-sm-row justify-sm-end ga-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_AddTeilnehmerZugriffDialog, {
                          "dialog-title": _ctx.$t('einstellungen.teilnehmerzugriff.dialog.treuhand.title'),
                          "dialog-infotext": _ctx.$t('einstellungen.teilnehmerzugriff.dialog.infotext.treuhand'),
                          "benutzer-rolle-label": _ctx.$t('benutzerrollen.treuhand'),
                          "teilnehmer-typ": "treuhand"
                        }, null, 8, ["dialog-title", "dialog-infotext", "benutzer-rolle-label"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_AddTeilnehmerZugriffDialog, {
                          "dialog-title": _ctx.$t('einstellungen.teilnehmerzugriff.dialog.title'),
                          "dialog-infotext": _ctx.$t('einstellungen.teilnehmerzugriff.dialog.infotext.praxisgruppe'),
                          "benutzer-rolle-label": _ctx.$t('benutzerrollen.praxisgruppe'),
                          "teilnehmer-typ": "praxisgruppe"
                        }, null, 8, ["dialog-title", "dialog-infotext", "benutzer-rolle-label"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_data_table, {
            headers: _ctx.headers,
            items: _ctx.teilnehmerZugriffList,
            "item-key": "teilnehmerName",
            "disable-pagination": "",
            "hide-default-footer": "",
            class: "elevation-1 nowhow-table",
            "must-sort": true,
            "items-per-page": -1
          }, {
            "item.teilnehmerZugriffTyp": _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('benutzerrollen.' + item.teilnehmerZugriffTyp.toLowerCase())), 1)
            ]),
            "item.action": _withCtx(({ item }) => [
              _createVNode(_component_ConfirmDialog, {
                title: "einstellungen.teilnehmerzugriff.deleteTitle",
                text: "einstellungen.teilnehmerzugriff.deleteText",
                onConfirm: ($event: any) => (_ctx.deleteTeilnehmerZugriff(item.teilnehmerZugriffId))
              }, {
                activatorElement: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, { flat: "" }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        icon: "mdi-delete"
                      })
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}